import { APPLICANT_LOADING, GET_APPLICANT, GET_APPLICANT_SUCCESS, GET_APPLICANT_FAIL, ADD_APPLICANT_SUCCESS, ADD_APPLICANT_FAIL, DELETE_APPLICANT_SUCCESS, DELETE_APPLICANT_FAIL, UPDATE_APPLICANT_SUCCESS, UPDATE_APPLICANT_FAIL, APPLICANT_RESET, APPLICANT_RESET_CREATE, GET_APPLICANT_ONE } from "./actionType";

const INIT_STATE = {
  applicants: [],
  applicantOne: null,
  applicantAdded: {},
  error: {},
};

const Applicant = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_APPLICANT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_APPLICANT:
          return {
            ...state,
            applicants: action.payload.data,
            isApplicantCreated: false,
            isApplicantSuccess: true,
            loading: false,
          };

        case GET_APPLICANT_ONE:
          return {
            ...state,
            applicantOne: action.payload.data,
            isApplicantSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_APPLICANT_FAIL:
      switch (action.payload.actionType) {
        case GET_APPLICANT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isApplicantCreated: false,
            isApplicantSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_APPLICANT: {
      return {
        ...state,
        isApplicantCreated: false,
        loading: true,
      };
    }

    case GET_APPLICANT_ONE: {
      return {
        ...state,
        applicantOne: action.payload.data,
        isApplicantCreated: false,
        loading: true,
      };
    }

    case APPLICANT_LOADING: {
      return {
        ...state,
        isApplicantCreated: false,
        loading: true,
      };
    }

    case ADD_APPLICANT_SUCCESS:
      return {
        ...state,
        isApplicantCreated: true,
        loading: false,
        applicants: [action.payload.data, ...state.applicants],
        applicantAdded: action.payload.data,
      };

    case ADD_APPLICANT_FAIL:
      return {
        ...state,
        isApplicantCreated: false,
        loading: false,
        error: action.payload,
      };

    case DELETE_APPLICANT_SUCCESS:
      return {
        ...state,
        loading: false,
        applicants: state.applicants.filter((applicant) => applicant.id.toString() !== action.payload.id.toString()),
      };

    case DELETE_APPLICANT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_APPLICANT_SUCCESS:
      return {
        ...state,
        loading: false,
        isApplicantCreated: true,
        applicants: state.applicants.map((applicant) => (applicant.id.toString() === action.payload.data.id.toString() ? { ...applicant, ...action.payload.data } : applicant)),
        applicantAdded: action.payload.data,
      };

    case UPDATE_APPLICANT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case APPLICANT_RESET_CREATE:
      return {
        ...state,
        isApplicantCreated: false,
      };

    case APPLICANT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Applicant;
